class CustomPriceRange extends HTMLElement {
  constructor() {
    super();

    this.minimumRange = this.querySelector('[data-price-min-range]');
    this.maximumRange = this.querySelector('[data-price-max-range]');
    this.minimumHidden = this.querySelector('[data-price-min-hidden]');
    this.maximumHidden = this.querySelector('[data-price-max-hidden]');
    this.minimumLabel = this.querySelector('[data-price-min-label]');
    this.bubble = this.querySelector('[data-price-bubble]');
    this.bubbleValue = this.querySelector('[data-price-bubble-value]');
    this.slider = this.querySelector('.custom-price-range__slider');
    this.maximumValue = Number(this.dataset.maximum || 0);
    this.currencyCode = this.dataset.currencyCode || '';
  }

  connectedCallback() {
    if (!this.minimumRange || !this.maximumRange || !this.slider) return;

    this.onMinimumInput = this.onMinimumInput.bind(this);
    this.onMaximumInput = this.onMaximumInput.bind(this);
    this.onMinimumChange = this.onMinimumChange.bind(this);
    this.onMaximumChange = this.onMaximumChange.bind(this);
    this.onResize = this.onResize.bind(this);

    this.minimumRange.addEventListener('input', this.onMinimumInput);
    this.maximumRange.addEventListener('input', this.onMaximumInput);
    this.minimumRange.addEventListener('change', this.onMinimumChange);
    this.maximumRange.addEventListener('change', this.onMaximumChange);
    window.addEventListener('resize', this.onResize);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateDisplay();
      });
      this.resizeObserver.observe(this.slider);
      if (this.bubble) this.resizeObserver.observe(this.bubble);
    }

    this.updateDisplay();
  }

  disconnectedCallback() {
    this.minimumRange?.removeEventListener('input', this.onMinimumInput);
    this.maximumRange?.removeEventListener('input', this.onMaximumInput);
    this.minimumRange?.removeEventListener('change', this.onMinimumChange);
    this.maximumRange?.removeEventListener('change', this.onMaximumChange);
    window.removeEventListener('resize', this.onResize);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  onResize() {
    this.updateDisplay();
  }

  onMinimumInput(event) {
    event.stopPropagation();
    this.updateMinimum();
  }

  onMaximumInput(event) {
    event.stopPropagation();
    this.updateMaximum();
  }

  onMinimumChange(event) {
    event.stopPropagation();
    this.submitPriceRange();
  }

  onMaximumChange(event) {
    event.stopPropagation();
    this.submitPriceRange();
  }

  updateMinimum() {
    if (Number(this.minimumRange.value) > Number(this.maximumRange.value)) {
      this.minimumRange.value = this.maximumRange.value;
    }
    this.updateDisplay();
  }

  updateMaximum() {
    if (Number(this.maximumRange.value) < Number(this.minimumRange.value)) {
      this.maximumRange.value = this.minimumRange.value;
    }
    this.updateDisplay();
  }

  updateDisplay() {
    const minimum = Number(this.minimumRange.value);
    const maximum = Number(this.maximumRange.value);
    const total = this.maximumValue || 1;

    const minimumPercentage = Math.max(0, Math.min((minimum / total) * 100, 100));
    const maximumPercentage = Math.max(0, Math.min((maximum / total) * 100, 100));

    this.style.setProperty('--price-min-position', `${minimumPercentage}%`);
    this.style.setProperty('--price-max-position', `${maximumPercentage}%`);

    if (this.minimumLabel) {
      this.minimumLabel.textContent = `${Math.round(minimum)} ${this.currencyCode}`;
    }

    if (this.bubbleValue) {
      this.bubbleValue.textContent = `${Math.round(maximum)} ${this.currencyCode}`;
    } else if (this.bubble) {
      this.bubble.textContent = `${Math.round(maximum)} ${this.currencyCode}`;
    }

    this.updateBubblePosition();
  }

  updateBubblePosition() {
    if (!this.bubble || !this.slider) return;

    const minimum = Number(this.minimumRange.value);
    const maximum = Number(this.maximumRange.value);
    const total = this.maximumValue || 1;

    const maximumPercentage = Math.max(0, Math.min((maximum / total) * 100, 100));

    requestAnimationFrame(() => {
      const sliderWidth = this.slider.clientWidth;
      const bubbleWidth = this.bubble.offsetWidth;

      if (!sliderWidth || !bubbleWidth) return;

      const rawLeft = (maximumPercentage / 100) * sliderWidth;
      const halfBubble = bubbleWidth / 2;

      const clampedLeft = Math.min(
        sliderWidth - halfBubble,
        Math.max(halfBubble, rawLeft)
      );

      this.bubble.style.left = `${clampedLeft}px`;
    });
  }

  submitPriceRange() {
    const minimum = Number(this.minimumRange.value);
    const maximum = Number(this.maximumRange.value);

    this.minimumHidden.value = minimum > 0 ? minimum : '';
    this.maximumHidden.value = maximum < this.maximumValue ? maximum : '';

    this.minimumHidden.dispatchEvent(new Event('input', { bubbles: true }));
    this.maximumHidden.dispatchEvent(new Event('input', { bubbles: true }));
    this.minimumHidden.dispatchEvent(new Event('change', { bubbles: true }));
    this.maximumHidden.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('custom-price-range')) {
  customElements.define('custom-price-range', CustomPriceRange);
}

document.addEventListener('click', (event) => {
  const clearSortButton = event.target.closest('[data-clear-custom-sort]');
  if (!clearSortButton) return;

  event.preventDefault();

  const desktopForm = document.querySelector('#FacetFiltersForm');
  const defaultSort = clearSortButton.dataset.defaultSort;
  if (!desktopForm || !defaultSort) return;

  const matchingInput = Array.from(
    desktopForm.querySelectorAll('input[name="sort_by"]')
  ).find((input) => input.value === defaultSort);

  if (!matchingInput) return;

  matchingInput.checked = true;
  matchingInput.dispatchEvent(new Event('input', { bubbles: true }));
});